import React, { useEffect } from 'react';
import { IonButton, IonButtons, IonCol, IonContent, IonHeader, IonMenuButton, IonModal, IonPage, IonRow, IonSelect, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { connect, useSelector } from 'react-redux';
import { Card, Grid, Col as TremorCol } from "@tremor/react";
import '../Page.css';
import FinancialsBarGraph from './FinancialsBarGraph';
import { useState } from 'react';
import {
  fetchOptions,
  showLoading,
  fetchDashboardSummary,
  showFeatureComingSoon,
  fetchCurrency,
  fetchBillingDetails,
  fetchOnboarding,
  fetchPropertiesUnitsTenants,
  sendPaymentReminder,
  fetchFinancialsGraph
} from '../../redux/actions';
import { useDispatch } from 'react-redux';
import UnpaidBalancesCard from './UnpaidBalancesCard';
import OverpaymentsCard from './OverpaymentsCard';
import { UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';
import { withRouter } from 'react-router-dom';
import * as PermChecker from '../../utils/PermUtils';
import _ from 'lodash';
import OccupancyCard from './occupancyCard';
import ArrearsOverview from './arrearsOverviewCard';
import CurrentMonthPaymentsCard from './currentMonthPayments';
import SubscriptionBalance from './subscriptionBalance';
import SMSBalance from './smsBalanceCard';
import CustomPropertySelect from '../../components/IonCustomPropertySelect';
import { SendBulkPaymentReminders } from '../Forms';
 

const HOME_PAGE = "/dashboard";
const BULK_PAYMENTS_PAGE = "/bulk-payments";


const Dashboard = ({history, location}) => {
  const dispatch = useDispatch();
  const properties = useSelector((state) => state.properties);
  const options = useSelector((state) => state.options);
  const summary = useSelector((state) => state.dashboardSummary);
  const currency = useSelector((state) => state.currency);
  const billing = useSelector((state) => state.billing);
  const onBoarding = useSelector((state) => state.onBoarding);

  const [propertyId, setPropertyId] = useState(Object.values(properties).length === 1 ? Object.values(properties)[0].propertyId : "");
  const [page, setPage] = useState(HOME_PAGE);
  const [bulkPaymentNotificationContext, setBulkPaymentNotificationContext] = useState(null);
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`;
  });
  const [endDate, setEndDate] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  });
  const [userViewPerms, setUserViewPerms] = useState({});
  const [graphData, setGraphData] = useState([]);
  const [xLabel, setXLabel] = useState("");
  
  const fetchInitialData = async () => {
    try {
      await Promise.all([
        (async () => {
          if (Object.keys(currency).length === 0) {
            dispatch(showLoading(true));
            await dispatch(fetchCurrency());
          }
        })(),
        (async () => {
          if (Object.keys(properties).length === 0) {
            await dispatch(fetchPropertiesUnitsTenants());
          }
        })(),
        (async () => {
          if (Object.keys(options).length === 0) {
            dispatch(showLoading(true));
            await dispatch(fetchOptions());
          }
        })(),
        (async () => {
          if (Object.keys(billing).length === 0) {
            dispatch(showLoading(true));
            await dispatch(fetchBillingDetails());
          }
        })(),
        (async () => {
          if (Object.keys(onBoarding).length === 0) {
            dispatch(showLoading(true));
            await dispatch(fetchOnboarding());
          }
        })(),
        (async () => {
          await dispatch(fetchFinancialsGraph());
        })()
      ]);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      await fetchInitialData();

      setPropertyId(Object.values(properties).length === 1 ? Object.values(properties)[0].propertyId : "");
      if(!_.isEmpty(options)){
        const canViewPayments = PermChecker.checkUserHasPermission(PermChecker.PAYMENT_MODEL, PermChecker.VIEW_PERM, options.userPermissions)
        const canViewProperties = PermChecker.checkUserHasPermission(PermChecker.PROPERTY_MODEL, PermChecker.VIEW_PERM, options.userPermissions)
        const canViewTenants = PermChecker.checkUserHasPermission(PermChecker.TENANT_MODEL, PermChecker.VIEW_PERM, options.userPermissions)
        setUserViewPerms({property: canViewProperties, payment: canViewPayments, tenant: canViewTenants})
      }

    };

    fetchData();
  }, [options, properties, dispatch]);

  

  useEffect(() => {
    const fetchData = async () => {
      dispatch(showLoading(true));

      let propertyIds = propertyId ? [propertyId] : [];
      const formattedStartDate = startDate || "";
      const formattedEndDate = endDate || "";

      const action = await dispatch(fetchFinancialsGraph({propertyIds}));
      if (action.payload.graphData) {
        setGraphData(action.payload.graphData);
      }

      let text = graphData.length > 1
        ? `${fetchMonthYear(graphData[0])} - ${fetchMonthYear(graphData[graphData.length - 1])}`
        : graphData.length === 1
        ? `${fetchMonthYear(graphData[0])}`
        : '';

      setXLabel(text);

      let param = { propertyIds, startDate: formattedStartDate, endDate: formattedEndDate };
      await dispatch(fetchDashboardSummary(param));
    };

    fetchData();

  }, [propertyId, startDate, endDate, dispatch]);

  useEffect(() => {
    if (location?.state?.openBulkPayments) {
      setBulkPaymentNotificationContext(location.state.notificationContext || null);
      setPage(BULK_PAYMENTS_PAGE);
    }
  }, [location]);

  // Refetch dashboard summary whenever the user navigates to this page (keeps stats fresh after payments, invoices, etc.)
  useIonViewDidEnter(() => {
    const propertyIds = propertyId ? [propertyId] : [];
    dispatch(fetchDashboardSummary({ propertyIds, startDate, endDate }));
  }, [propertyId, startDate, endDate, dispatch]);

  const fetchMonthYear = (data) => {
    return `${data["month"]} ${data["year"]}`;
  }

  const handleSendBalanceReminder = async (tenantId) => {
    dispatch(showLoading(true));
    await dispatch(sendPaymentReminder({tenantIds: [tenantId]}));
  };

  const handleSelectProperty = (event) => {
    event.preventDefault();
    let value = event.target.value;
    setPropertyId(value);
  }

  const handleRecordPayment = () => {
    history.push(UNIFORM_RESOURCE_LOCATORS.payments);
  };

  const handleSendReminder = () => {
    setPage(BULK_PAYMENTS_PAGE);
  };
  


  const handleBulkPaymentRemindersForm = () => {
    setPage(HOME_PAGE);
  };

  let date = new Date();
  let paymentsThisMonth = 0;
  let unpaidAmount = 0;
  let overpaidAmount = 0;
  let unpaidCount = 0;
  let overpaidCount = 0;
  let vacant = 0;
  let occupied = 0;
  let countUnassignedPayments = 0;
  let customerCurrency = "";

  if (summary && Object.keys(summary).length > 0) {
    let {
      payments,
      units,
      countUnassignedPayments,
      unpaidTenantsAmount,
      overpaidTenantsAmount,
      unpaidTenantsCount,
      overpaidTenantsCount
    } = summary;


    unpaidAmount = unpaidTenantsAmount ?? 0;
    overpaidAmount = overpaidTenantsAmount ?? 0;

    unpaidCount = unpaidTenantsCount ?? 0;
    overpaidCount = overpaidTenantsCount ?? 0;

    paymentsThisMonth = payments?.thisMonth;
    vacant = parseInt(units?.vacant);
    occupied = parseInt(units?.occupied);
    customerCurrency = currency?.customerCurrency;
    countUnassignedPayments = parseInt(countUnassignedPayments); // TODO for unassigned payments alert component
  }

  const renderDashboard = () => (
    <div>

      <IonRow className='mx-3 my-2'>
        <IonCol xs={12} lg={12} className=''>
            <IonSelect
                type="select"
                name="select-property"
                interface="popover"
                id="propertyFilter"
                fill="solid"
                className="filter-tenants"
                onIonChange={handleSelectProperty}
                value={propertyId}
            >
                <CustomPropertySelect propertiesArray={Object.values(properties) || []}/>
            </IonSelect>
            </IonCol>
      </IonRow>
      
      <Grid numItemsLg={10} className="gap-6 mt-6">
        <TremorCol numColSpan={1} numColSpanLg={5}>
          <UnpaidBalancesCard
            totalUnpaid={unpaidAmount}
            unpaidCount={unpaidCount}
            currency={customerCurrency}
            handleSendReminders={handleSendReminder}
            onView={() => { userViewPerms.tenant? history.push(UNIFORM_RESOURCE_LOCATORS.tenants): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
            options={options}
          />
        </TremorCol>
        <TremorCol numColSpan={1} numColSpanLg={5}>
          <OverpaymentsCard
            totalOverpaid={overpaidAmount}
            overpayCount={overpaidCount}
            currency={customerCurrency}
            onView={() => { userViewPerms.tenant? history.push(UNIFORM_RESOURCE_LOCATORS.tenants): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
            options={options}
          />
        </TremorCol>

        <TremorCol numColSpan={1} numColSpanLg={5}>
          <OccupancyCard
            vacancies={vacant}
            occupied={occupied}
            options={options}
            percentageOccupied={parseInt(summary?.units?.percentageOccupied) || 0}
            handleAddTenant={() => { userViewPerms.tenant? history.push(UNIFORM_RESOURCE_LOCATORS.tenants): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
            handleDeleteTenant={() => { userViewPerms.tenant? history.push(UNIFORM_RESOURCE_LOCATORS.tenants): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
            setUserViewPerms={userViewPerms}
            onClick={() => { userViewPerms.property? history.push(UNIFORM_RESOURCE_LOCATORS.properties): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
          />
        </TremorCol>

        <TremorCol numColSpan={1} numColSpanLg={5}>
          <CurrentMonthPaymentsCard
            billedThisMonth={summary?.payments?.billedThisMonth || 0}
            totalPaid={paymentsThisMonth || 0}
            overPaid={0}
            currency={customerCurrency}
            percentagePaid={parseInt(summary?.payments?.percentagePaid) || 0}
            handleRecordPayment={handleRecordPayment}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={(e) => {
              const v = e.target.value; // already YYYY-MM-DD
              if (endDate && v && v > endDate) {
                setEndDate(v);
              }
              setStartDate(v);
            }}
            onEndDateChange={(e) => {
              const v = e.target.value; // already YYYY-MM-DD
              if (startDate && v && v < startDate) {
                // snap to start
                setEndDate(startDate);
              } else {
                setEndDate(v);
              }
            }}
            onClick={() => { userViewPerms.payment? history.push(UNIFORM_RESOURCE_LOCATORS.payments): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
          />
        </TremorCol>

        <TremorCol numColSpan={1} numColSpanLg={5}>
          <ArrearsOverview
            arrears={summary?.arrears || []}
            currency={customerCurrency}
            handleSendBalanceReminder={handleSendBalanceReminder}
            onClick={() => { userViewPerms.tenant? history.push(UNIFORM_RESOURCE_LOCATORS.tenants): history.push(UNIFORM_RESOURCE_LOCATORS.dashboard) }}
          />
        </TremorCol>

        <TremorCol numColSpan={1} numColSpanLg={5}>
          <SubscriptionBalance
            subscriptionAmount={billing?.customerAccount?.subscriptionBalance || 0}
            subscriptionExpiryDate={billing?.customerAccount?.nextBillingDate || null}
            currency={customerCurrency}
            onClick={() => { history.push(UNIFORM_RESOURCE_LOCATORS.billing) }}
          />
          <SMSBalance
            smsAmount={billing?.customerAccount?.smsBalance || 0}
            lastSmsPaymentDate={billing?.customerAccount?.lastSmsPaymentDate || null}
            currency={customerCurrency}
            onClick={() => { history.push(UNIFORM_RESOURCE_LOCATORS.billing) }}
          />
        </TremorCol>

      </Grid>

      <div className="mt-6">
        <Card className="h-100">
          <FinancialsBarGraph
            graphData={graphData}
            xLabel={xLabel}
          />
        </Card>
      </div>
    </div>
  )

  const renderBulkPayments = () => (
              <IonModal isOpen={page === BULK_PAYMENTS_PAGE} onDidDismiss={handleBulkPaymentRemindersForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>
                            Bulk Payment Reminders
                        </IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={handleBulkPaymentRemindersForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <SendBulkPaymentReminders
                    notificationContext={bulkPaymentNotificationContext}
                  />
                </IonContent>
              </IonModal>
  )


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>
            {page === HOME_PAGE ? "Dashboard" : "Bulk Payments"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="ion-padding">
        {page === HOME_PAGE && renderDashboard()}
        {page === BULK_PAYMENTS_PAGE && renderBulkPayments()}
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state) => {
  return {
      properties: state.properties,
      units: state.units,
      tenants: state.tenants,
      options: state.options,
      dashboardSummary: state.dashboardSummary,
      currency: state.currency,
      billing: state.billing,
      onBoarding: state.onBoarding
  };
}

const mapDispatchToProps = () => {
  return {
    fetchOptions,
    showLoading,
    fetchDashboardSummary,
    showFeatureComingSoon,
    fetchCurrency,
    fetchBillingDetails,
    fetchOnboarding,
    fetchPropertiesUnitsTenants,
    sendPaymentReminder,
    fetchFinancialsGraph
  };
}

export default withRouter(connect(
  mapStateToProps, mapDispatchToProps
)(Dashboard));